import Vue from 'vue'
import Router from 'vue-router'
import axios from "axios";
import OrderList from "../views/orders/OrderList";
import OrderInfo from "../views/orders/OrderInfo";

import Reservations from "../views/lines/Reservations.vue";
import LinesList from "../views/lines/LinesList.vue";
import LineReserveTimes from "../views/lines/LineReserveTimes.vue";
import Help from "../views/settings/Help.vue";
import CustomerList from "../views/orders/CustomerList.vue";
import MessageList from "../views/messages/MessageList.vue";
import Notifications from "../views/settings/Notifications.vue";
import PromotionReport from "../views/promotions/PromotionReport.vue";
import PromotionEdit from "../views/promotions/PromotionEdit.vue";
import PromotionCreate from "../views/promotions/PromotionCreate.vue";
import promotions from "../views/promotions/promotions.vue";
import MyLinesList from "../views/lines/MyLinesList.vue";
import deposits from "../views/deposits/deposits.vue";
import Transactions from "../views/deposits/Transactions.vue";
import Settlements from "../views/deposits/Settlements.vue";
import SmsCredits from "../views/deposits/SmsCredits.vue";
import SmsCreditsPage from "../views/deposits/SmsCredits.vue";
import PortfolioIndex from "../views/portfolio/PortfolioIndex.vue";
import CategoryList from "../views/categories/CategoryList.vue";
// axios.defaults.headers.post['Authorization'] = localStorage.getItem('token');
axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token');
axios.defaults.headers.get['Authorization'] = 'Bearer ' + localStorage.getItem('token');

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('../views/Dashboard');
const AdminList = () => import('../views/users/AdminList');
const UserList = () => import('../views/users/UserList');

const UserProfile = () => import('../views/users/UserProfile');


//Products


// Views - Notifications
const Settings = () => import('../views/settings/Settings');

// Views - Pages
const Page404 = () => import('../views/pages/Page404');
const Page500 = () => import('../views/pages/Page500');
const Login = () => import('../views/pages/Login');
const Register = () => import('../views/pages/Register');


Vue.use(Router);

let router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({y: 0}),
    routes: configRoutes(),

});
export default router

router.beforeEach((to, from, next) => {
    console.log("before each" + " token is " + localStorage.getItem('token'));
    // console.log("before each"+next);
    if (to.path == '/') {
        //  window.location.href = '/home';
    }

    // document.body.scro
if(from.meta.saveScroll){
    console.log("path has save scroll")
    localStorage.setItem("scroll"+window.location.path,window.pageYOffset.toString())
}
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log("validate requiresAuth");

        if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
            console.log("validate is null");

            next({
                path: 'dashboard/login',
                params: {nextUrl: to.fullPath}
            })
        } else {
             validate_user(next, to);


            // let user = JSON.parse(localStorage.getItem('user'))
            // if(to.matched.some(record => record.meta.is_admin)) {
            //     if(user.is_admin == 1){
            //         next()
            //     }
            //     else{
            //         next({ name: 'userboard'})
            //     }
            // }else {
            //     next()
            // }
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        // if(localStorage.getItem('jwt') == null){
        next()
        // }
        // else{
        //     next({ name: 'userboard'})
        // }
    } else {
        next()
    }
});

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',

            name: "Panel",
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/dashboard',
            // redirect: '/dashboard',
            name: "Dashboard",
            meta: {
                requiresAuth: true
            },
            component: TheContainer,
            children: [
                {
                    path: '/',
                    name: "Dashboard",
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                    }
                },{
                    path: 'my-customers',
                    name: "مشتریان من",
                    component: CustomerList,
                    meta: {
                        requiresAuth: true,
                    }
                },{
                    path: 'portfolios',
                    name: "نمونه کار ها",
                    component: PortfolioIndex,
                    meta: {
                        requiresAuth: true,
                    }
                },{
                    path: 'sms-credits',
                    name: "اعتبار پیامکی",
                    component: SmsCreditsPage,
                    meta: {
                        requiresAuth: true,
                    }
                },

                {
                    path: 'categories',
                    name: "Categories",
                    props: true,
                    component: {render (c){return c('router-view')}},
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'list',
                            name: "Lines List",
                            props: true,
                            component: CategoryList,
                            meta: {
                                requiresAuth: true,
                            }
                        },

                    ]
                },
                {
                    path: 'lines',
                    name: "Lines",
                    props: true,
                    component: {render (c){return c('router-view')}},
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'list',
                            name: "Lines List",
                            props: true,
                            component: LinesList,
                            meta: {
                                requiresAuth: true,
                            }
                        },{
                            path: 'my-list',
                            name: "My Lines List",
                            props: true,
                            component: MyLinesList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'reserve_times/:id/:admin_id',
                            name:"lines_reservation_times",
                            props: true,
                            component: LineReserveTimes,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'reservations/:id/:admin_id',
                            name:"Reservation List",
                            props: true,
                            component: Reservations,
                            meta: {
                                requiresAuth: true,
                            }
                        },

                    ]
                },
                {
                    path: 'promotions',
                    name: "Promotions",
                    props: true,
                    component: {render (c){return c('router-view')}},
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        // جشنواره‌ها
                        {
                            path: 'promotions',
                            name: 'PromotionsIndex',
                            component: promotions,
                            meta: { requiresAuth: true }
                        },
                        {
                            path: 'create',
                            name: 'PromotionCreate',
                            component:PromotionCreate,
                            meta: { requiresAuth: true }
                        },
                        {
                            path: 'edit/:id',
                            name: 'PromotionEdit',
                            component: PromotionEdit,
                            meta: { requiresAuth: true }
                        },
                        {
                            path: 'report/:id',
                            name: 'PromotionReport',
                            component:PromotionReport,
                            meta: { requiresAuth: true}
                        }

                    ]
                },
                {
                    path: 'users',
                    name: "staffs",
                    props: true,
                    component: {render (c){return c('router-view')}},
                    meta: {
                        requiresAuth: true,
                    },
                    children:[

                        {
                            path: 'admins',
                            name: "admins",
                            props: true,
                            component: AdminList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "admins"
                            }
                        },
                        // {
                        //     path: 'admins',
                        //     name: "Users List",
                        //     props: true,
                        //     component: UserList,
                        //     meta: {
                        //         requiresAuth: true,
                        //         requiresRole: "admins"
                        //     }
                        // },
                        {
                            path: 'profile',
                            name: "Profile",
                            props: true,
                            component: UserProfile,
                            meta: {
                                requiresAuth: true,

                            }
                        },
                    ]
                },

                //*************************************************
                {
                    path: '/dashboard/settings',
                    name: "settings",
                    props: true,
                    component: {render (c){return c('router-view')}},

                    meta: {
                        requiresAuth: true,
                        requiresRole: "ui_settings"
                    },
                    children:[

                        {
                            path: 'main-setting',
                            name: "Main Settings",
                            props: true,
                            component: Settings,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "basic_settings"
                            }
                        },
                        {
                            path: 'help',
                            name: "Help",
                            props: true,
                            component: Help,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "basic_settings"
                            }
                        },
                    ]
                },

                //*************************************************
                {
                    path: '/dashboard/deposits',
                    name: "deposits",
                    props: true,
                    component: {render (c){return c('router-view')}},

                    meta: {
                        requiresAuth: true,
                        requiresRole: "admins"
                    },
                    children:[


                        {
                            path: 'transactions',
                            name: "transactions",
                            props: true,
                            component: Transactions,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "admins"
                            }
                        },
                        {
                            path: 'settlements',
                            name: "settlements",
                            props: true,
                            component: Settlements,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "admins"
                            }
                        },
                        {
                            path: 'deposits',
                            name: "Deposits",
                            props: true,
                            component: deposits,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "admins"
                            }
                        },

                    ]
                },


                //****************************************
                //****************************************
                {
                    path: '/dashboard/messages',
                    name: "support",
                    props: true,
                    component: {render (c){return c('router-view')}},

                    meta: {
                        requiresAuth: true,
                    },
                    children:[

                        {
                            path: 'list',
                            name: "MessageList",
                            props: true,
                            component: MessageList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ]
                },
                //******************************************
                {
                    path: '/dashboard/notifications',
                    name: "support",
                    props: true,
                    component: {render (c){return c('router-view')}},

                    meta: {
                        requiresAuth: true,
                    },
                    children:[

                        {
                            path: 'list',
                            name: "MessageList",
                            props: true,
                            component: Notifications,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ]
                },

                //*************************************************


                //*************************************************


            ]
        },
        {
            path: 'dashboard/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '/dashboard/404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: '/dashboard/login',
                    name: 'Login',
                    component: Login
                },

                {
                    path: '/register',
                    name: 'Register',
                    component: Register
                }
            ]
        }
    ]
}

function validate_user(next, to) {
    let self = this;
    const formData = new FormData()
    let url;
    url = "/api/admin/user/validate-token";

    formData.append('token', localStorage.getItem('token'))

    axios.post(url, formData,{}).then((res) => {
        console.log("validate token is " + res.data);


        if (res.data.validate) {
            localStorage.setItem("permissions",JSON.stringify(res.data.permissions))
            console.log("validate is true");
            let meta_role = to.meta.requiresRole;
            // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
            if (meta_role == null) {
                console.log("requiresRole is null");
                next();

            } else {
                console.log("requiresRole is " + meta_role);
                let permissions = res.data.permissions;
                if (permissions.includes(meta_role)) {
                    console.log("user has permissions ");
                    next();

                } else {
                    next({
                        path: '/dashboard/404',
                        params: {nextUrl: to.fullPath}
                    });
                }

            }

        } else {
            console.log("validate is false");

            next({
                path: '/dashboard/login',
            })
        }
        // return res.data;
    }).catch(function (error) {
            next({
                path: '/dashboard/login',
            })
            console.log(error);
        });

}

